/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, bool, func, string, number, shape,
} from 'prop-types';
import { bindActionCreators } from 'redux';
import ReactHtmlParser from 'react-html-parser';
import IconButton from '@material-ui/core/IconButton';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Typography from '@material-ui/core/Typography';
import { ducks as checkoutDucks } from '../../../../../../../../state/ducks/Checkout';
import { MiniCartStyle, StyledDialog, StyledDialogTitle } from './style/MiniCartStyle';
import { getFeatureFlags } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import GraphqlUpSellProducts from '../GraphqlUpSellProducts/GraphqlUpSellProducts';
import { getShopTheSite, resetShopTheSiteStorage } from '../../../../../../Account/utils/shopTheSite';
import { getContactId } from '../../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import SlideOutMiniCart from '../SlideOutMiniCart/SlideOutMiniCart';
import ItemImage from '../ItemImage/ItemImage';

import { triggerInterstitialLogin } from '../../../../../../../../state/ducks/Member/ducks/Auth/Auth-Actions';
import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const {
    common: {
        commonSelectors: {
            getCartCount,
            getOrderTotalProduct,
            getOrderId,
            getLastAddedOrderItemDetails,
            getPassportData,
        },
    },
} = checkoutDucks;

const styles = (theme) => MiniCartStyle(theme);

const MiniCart = ({
    classes,
    minicartModalOpen,
    handleMiniCartModalClick,
    product,
    history,
    cartCount,
    orderTotalProduct,
    orderId,
    // actionValidateShopCart,
    actionTriggerInterstitialLogin,
    featureFlags,
    productAdded,
    contactId,
    passportData,
    isPassportBundleProduct,
    track,
}) => {
    const [giftListURL, setGiftListURL] = useState({});

    if (!productAdded) return null;
    const productDetails = productAdded.catalogEntryVO || {};
    const productPartNumber = productDetails?.skuCode || product?.partNumber || '';
    const productAvailability = (product.partNumber === productPartNumber) ? product.availability?.deliveryMessage || '' : '';
    const productPrice = productDetails?.skuOfferPrice || product?.skuOfferPrice || 0;
    const productImageName = productDetails?.skuImageName || product?.image?.name || '';
    const productImagePath = productDetails?.imagePath || product?.image?.path || '';

    useEffect(() => {
        // GiftList - get Shop The Site content
        const giftList = getShopTheSite(contactId) || {};
        const { giftListURL: url } = giftList;
        setGiftListURL(url);
    }, [contactId]);

    const handelOncloseState = () => {
        handleMiniCartModalClick(false);
        // Clear Shop The Site data
        resetShopTheSiteStorage(contactId);
        track({
            eventName: 'feature_interaction',
            eventCategory: 'Product Page',
            eventAction: 'Mini Cart',
            eventLabel: 'Close Mini Cart',
        });
    };

    const splitSkuId = (partNumber) => {
        const skuId = partNumber.match(/[^-_]*$/);
        return (skuId.length > 0) ? skuId[0] : '';
    };

    const handleReturnToGiftList = () => {
        // Clear Shop The Site data
        resetShopTheSiteStorage(contactId);
        if (giftListURL) history.push(giftListURL);
        return null;
    };

    const handlePageEvent = (eventLabel) => {
        track({
            eventName: 'feature_interaction',
            eventCategory: 'Product Page',
            eventAction: 'Mini Cart',
            eventLabel,
        });
    };

    const handleCheckout = (redirectKey) => {
        if (cartCount < 1) return null;
        switch (redirectKey) {
            case 'home':
                handlePageEvent('Continue Shopping');
                return history.push('/');
            case 'cart':
                return history.push(`/checkout/cart/${orderId}`);
            case 'checkout':
                // TODO ::: commenting out for now need to verifiy if actionValidateShopCart is required
                // actionValidateShopCart({ orderId, history });
                if (featureFlags['is-interstitial-login-enabled']) {
                    actionTriggerInterstitialLogin(history);
                } else {
                    history.push(`/checkout/shipping/${orderId}`);
                    handlePageEvent('Checkout');
                }
                return true;
            default:
                return null;
        }
    };

    let productName = ReactHtmlParser(productDetails?.parentSkuName || product?.name || '');
    if (isPassportBundleProduct?.enable) {
        const bundleText = passportData?.passport_bundle?.pdpage_passport_bundle_title || ' & Passport Bundle';
        productName = `${productName} ${bundleText}`;
    }
    const isMiniCartV2Enabled = featureFlags['is-mini-cart-v2-enabled'];
    return (
        <> {!isMiniCartV2Enabled && minicartModalOpen
            ? (
                <SlideOutMiniCart
                    openDrawer={minicartModalOpen}
                    closeDrawer={handelOncloseState}
                    handleCheckout={handleCheckout}
                />
            )
            : (
                <StyledDialog
                    open={minicartModalOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    id="minicart"
                >
                    <StyledDialogTitle>
                        <IconButton
                            aria-label="close"
                            className={classes.closeButton}
                            onClick={() => handelOncloseState()}
                            data-testid="close-dialog"
                        >
                            <CloseIcon />
                        </IconButton>
                    </StyledDialogTitle>
                    <DialogContent>
                        <Grid container className={classes.modalContainer}>
                            <Grid item sm={12} md={6} className={classes.modalItem}>
                                <Grid container>
                                    <Grid item sm={12} md={12} className={`${classes.addedCartItem} ${classes.titleBorderBottom} ${classes.alignIcon}`}>
                                        <CheckCircleIcon />
                                        <Typography variant="body2">
                                            1 item Added to your cart
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12}>
                                        <Typography variant="subtitle1" className={classes.productTitle}>
                                            {ReactHtmlParser(productName)}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12} className={classes.productDescription}>
                                        <Typography variant="body2" id="product-price">
                                            <b>${productPrice}</b>
                                        </Typography>
                                        <Typography variant="caption" id="product-part-number">
                                            <b>{splitSkuId(productPartNumber)}</b>
                                        </Typography>
                                        {productAvailability && (
                                            <Typography variant="caption" className={classes.fontSize12} id="product-availability">
                                                <b>{ReactHtmlParser(productAvailability)}</b>
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid item sm={12} md={12} className={classes.productImageUI}>
                                        <ItemImage
                                            imagePath={productImagePath}
                                            imageName={productImageName}
                                            typeImg="x"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} className={classes.modalItem}>
                                <Grid container className={classes.chargesShippingContainer}>
                                    <Grid item sm={12} md={12} className={classes.titleBorderBottom}>
                                        <Typography variant="body2">
                                            <b>{`${(cartCount || 0)} ITEMS IN YOUR CART`}</b>
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12} className={classes.priceAttributeContainer}>
                                        <Typography variant="body2">
                                            <b>Subtotal:</b>
                                        </Typography>
                                        <Typography variant="body2" className={classes.floatRight}>
                                            <b>{`$${(orderTotalProduct || 0)}`}</b>
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12} className={classes.titleBorderBottom}>
                                        <Typography variant="caption">
                                            (Subtotal excludes shipping, discounts and tax.)
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12} className={classes.buttonDialogAction}>
                                        <Button
                                            className={classes.selectView}
                                            onClick={() => handleCheckout('checkout')}
                                            data-testid="view-checkout"
                                        >
                                            Checkout
                                        </Button>
                                    </Grid>
                                    <Grid item sm={12} md={12} className={classes.viewCartWrapper}>
                                        <Grid item sm={7} className={`${classes.backToGiftListAction} ${classes.alignIcon}`} style={{ display: `${giftListURL ? 'flex' : 'none'}` }}>
                                            <ArrowLeftIcon />
                                            <Typography
                                                variant="body2"
                                                onClick={() => handleReturnToGiftList()}
                                                data-testid="view-giftlist"
                                            >
                                                <b>RETURN TO GIFT LIST</b>
                                            </Typography>
                                        </Grid>
                                        <Grid item sm={`${giftListURL ? 5 : 12}`} className={`${classes.viewCartDialogAction} ${classes.alignIcon}`}>
                                            <Typography
                                                variant="body2"
                                                onClick={() => handleCheckout('cart')}
                                                data-testid="view-cart"
                                            >
                                                <b>VIEW CART</b>
                                            </Typography>
                                            <ArrowRightIcon />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    {featureFlags['is-mini-cart-upsells-enabled'] && (
                        <GraphqlUpSellProducts />
                    )}
                </StyledDialog>
            )}
        </>
    );
};

MiniCart.propTypes = {
    classes: object.isRequired,
    minicartModalOpen: bool.isRequired,
    handleMiniCartModalClick: func.isRequired,
    product: shape({
        partNumber: string.isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
        }).isRequired,
    }),
    history: object.isRequired,
    cartCount: number.isRequired,
    orderTotalProduct: number.isRequired,
    orderId: string.isRequired,
    // actionValidateShopCart: func.isRequired,
    featureFlags: object.isRequired,
    productAdded: shape({
        catalogEntryVO: shape({
            parentSkuName: string.isRequired,
            parentSkuCode: string.isRequired,
            skuOfferPrice: number.isRequired,
            skuImageName: string.isRequired,
            imagePath: string.isRequired,
        }),
    }).isRequired,
    contactId: string,
    actionTriggerInterstitialLogin: func.isRequired,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    passportData: shape({
        passport_bundle: {
            pdpage_passport_bundle_title: string,
        },
    }),
    track: func.isRequired,
};

MiniCart.defaultProps = {
    contactId: '',
    product: {
        partNumber: '',
        availability: {
            deliveryMessage: '',
        },
    },
    passportData: {},
    isPassportBundleProduct: {},
};

const mapStateToProps = (state) => ({
    contactId: getContactId(state),
    cartCount: getCartCount(state),
    orderTotalProduct: getOrderTotalProduct(state),
    orderId: getOrderId(state),
    featureFlags: getFeatureFlags(state),
    productAdded: getLastAddedOrderItemDetails(state),
    passportData: getPassportData(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionTriggerInterstitialLogin: bindActionCreators(triggerInterstitialLogin, dispatch),
    track: bindActionCreators(trackEvent, dispatch),
    // actionValidateShopCart: bindActionCreators(checkoutActions.validateShopCart, dispatch),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles),
);

export default enhance(MiniCart);
